module.exports = "/app/main/img/extra-email-v2.5c94f1ad.png";